export enum IFields {
  position = 'position',
  notes = 'notes',
  notesStatus = 'notesStatus',
  flag = 'flag',
  error = 'error',
  level = 'level',
  conceptLinkerStatus = 'conceptLinkerStatus',
  nLockedVoc = 'nLockedVoc',
  nLockedByVoc = 'nLockedByVoc',
  nLockedPanel = 'nLockedPanel',
  nLockedByPanel = 'nLockedByPanel',
  nTestSentences = 'nTestSentences',
  nAutoCompounds = 'nAutoCompounds',
  itemWithSource = 'itemWithSource',
  overwrite = 'overwrite',
  listening = 'listening',
  statusRecording = 'statusRecording',
  status = 'status',
  nUses = 'nUses',
  showToUser = 'showToUser',
  orig = 'orig',
  verified = 'verified',
  pngOriginal = 'pngOriginal',
  png = 'png',
  nSegments = 'nSegments',
  nReadingExercises = 'nReadingExercises',
  nTrainerSegments = 'nTrainerSegments',
  nExercises = 'nExercises',
  none = 'none',
  review = 'review',
  done = 'done',
  showInLibrary = 'showInLibrary',
  searchableInLibrary = 'searchableInLibrary',
  illustration = 'illustration',
  // Concept Linker Validator fields
  conceptValidatorActions = 'actions',
  moduleNavigation = 'navigation_data',
  conceptValidatorAiStatus = 'async_task_status',
  conceptValidatorAiResult = 'ai_result',
  conceptValidatorItemStatus = 'status',
  aiLinkerText = 'ai_result_text',
  conceptValidatorStatus = 'status',
  itemSourceGuesserActions = 'actions',
  itemSourceGuesserAiStatus = 'async_task_status',
  itemSourceGuesserAiResult = 'ai_result',
  itemSourceGuesserStatus = 'status',
  itemSourceGuesserItem = 'item',
  itemSourceSentenceTranslationValidatorActions = 'actions',
  itemSourceSentenceTranslationValidatorAiStatus = 'async_task_status',
  itemSourceSentenceTranslationValidatorAiResult = 'ai_result',
  itemSourceSentenceTranslationValidatorStatus = 'status',
  itemSourceSentenceTranslationValidatorItem = 'item',
  itemSourceSentenceTranslationValidatorSentence = 'sentence',
  itemSourceMeanValidatorActions = 'actions',
  itemSourceMeanValidatorAiStatus = 'async_task_status',
  itemSourceMeanValidatorAiResult = 'ai_result',
  itemSourceMeanValidatorStatus = 'status',
  itemSourceMeanValidatorItem = 'item',
  itemSourceMeanValidatorMeaning = 'meaning',
  action = 'action',
  actions = 'actions',
  ai_result = 'ai_result',
  async_task_status = 'async_task_status',
  hasExample = 'hasExample',
  isInvariable = 'isInvariable',
  test_result = 'test_result',
  result_column = 'result_column',
  item_info = 'item_info',
  agent_prompt_log = 'agent_prompt_log',
  retry_action = 'retry_action',
  confidence = 'confidence',
  reasoning = 'reasoning',
  is_validated = 'is_validated',
  translationStatus = 'translationStatus',
  // AI Illustration fields
  original_png = 'original_png',
  alternative_1 = 'alternative_1',
  alternative_2 = 'alternative_2',
  // Hanzi
  complete = 'complete',
  inStandard = 'inStandard',
  componentOnly = 'componentOnly',
  hasCard = 'hasCard',
  bareStroke = 'bareStroke',
  // Translation Dashboard export/import
  export = 'export',
  import = 'import',
}
